import { HOST_API_URL } from "../../config";
import { TrySimplelanguages } from "../../types/types";

export interface IGetTokenRequest {
  username: string;
  password: string;
}

export function GetTokenCodeSample(jsonString: string): TrySimplelanguages {

  const csharpCode = `var client = new HttpClient();
var request = new HttpRequestMessage(HttpMethod.Post, "${HOST_API_URL}/accounts/getToken");
var content = new StringContent(${jsonString}, System.Text.Encoding.UTF8, "application/json");
request.Content = content;
var response = await client.SendAsync(request);
response.EnsureSuccessStatusCode();
Console.WriteLine(await response.Content.ReadAsStringAsync());`;

  const javaCode = `OkHttpClient client = new OkHttpClient();
MediaType mediaType = MediaType.parse("application/json; charset=utf-8");
RequestBody body = RequestBody.create(mediaType, ${jsonString});
Request request = new Request.Builder()
  .url("${HOST_API_URL}/accounts/getToken")
  .post(body)
  .addHeader("Content-Type", "application/json")
  .build();
Response response = client.newCall(request).execute();
System.out.println(response.body().string());`;

  const javascriptCode = `const response = await fetch("${HOST_API_URL}/accounts/getToken", {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: ${jsonString}
});
if (!response.ok) throw new Error("Request failed: " + response.status);
const data = await response.json();
console.log(data);`;

  const phpCode = `<?php
$ch = curl_init();
curl_setopt_array($ch, [
  CURLOPT_URL => '${HOST_API_URL}/accounts/getToken',
  CURLOPT_RETURNTRANSFER => true,
  CURLOPT_POST => true,
  CURLOPT_HTTPHEADER => ['Content-Type: application/json'],
  CURLOPT_POSTFIELDS => ${jsonString}
]);
$response = curl_exec($ch);
if ($response === false) {
  throw new Exception(curl_error($ch));
}
curl_close($ch);
echo $response;`;

  const pythonCode = `import requests

url = "${HOST_API_URL}/accounts/getToken"
headers = {"Content-Type": "application/json"}
payload = ${jsonString}

resp = requests.post(url, headers=headers, data=payload)
resp.raise_for_status()
print(resp.json())`;

  return GetLanguages({
    Csharp: csharpCode,
    Java: javaCode,
    JavaScript: javascriptCode,
    PHP: phpCode,
    Python: pythonCode
  })

}

function GetLanguages(props: { Csharp: string; Java: string; JavaScript: string; PHP: string; Python: string; }): TrySimplelanguages {
  return props;
}
